import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import api from "@/lib/api";
import BlockRenderer from "@/components/BlockRenderer";
import { PageBanner } from "@/pages/Listings";

export default function CmsPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => { api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setMissing(true)); }, [slug]);
  if (missing) return <div className="flex min-h-screen items-center justify-center bg-dir-bg text-dir-muted">Page not found.</div>;
  if (!page) return <div className="flex min-h-screen items-center justify-center bg-dir-bg text-dir-gold">Loading…</div>;
  return <main className="min-h-screen bg-dir-bg"><PageBanner label={page.subtitle || "DIR Nation"} title={page.title} desc={page.excerpt} image={page.featured_image} /><article className="mx-auto max-w-4xl px-4 py-14 sm:px-6">{page.rich_content?.html && <div className="prose-dir text-dir-muted" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(page.rich_content.html) }} />}<div className="mt-8"><BlockRenderer blocks={page.blocks} /></div></article></main>;
}
